import React, { FunctionComponent } from 'react';

import { Attachment, PreviewType } from '@api/v4/attachments/attachmentTypes';
import { ProcessingVideoPreview } from '@components/asset/modal/tabs/asset_details/asset_preview/ProcessingVideoPreview';
import VideoJSPlayer from '@components/video/videojs_player/main';

export const MuxVideoPreview: FunctionComponent<Attachment> = ({
  cdn_url: cdnUrl,
  mimetype,
  mux_hls_url: muxHlsUrl,
  preview_type: previewType,
  url
}) => {
  let videoOptions = {
    sources: [
      {
        src: muxHlsUrl,
        type: "application/x-mpegURL"
      }
    ]
  };

  if (previewType === PreviewType.VideoOther) {
    videoOptions = {
      sources: [
        {
          src: cdnUrl,
          type: mimetype
        }
      ]
    };
  } else if (!muxHlsUrl) {
    // if a Mux video but has no playerId and thus no url
    // then show processing video
    return <ProcessingVideoPreview />;
  }

  return (
    <div
      id="advanced-video"
      className="m-show-full-size-display s-expand-view"
      data-private
      data-testid="asset-preview--video-player"
    >
      <VideoJSPlayer
        className="m-show-full-size-display"
        {...videoOptions}
      />
      ;
    </div>
  );
};
